export enum SoftwareProductValidation {
	ValidContract,
}
